import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-param-duplication-module',
  templateUrl: './param-duplication-module.component.html',
  styleUrls: ['./param-duplication-module.component.scss']
})
export class ParamDuplicationModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
